<template>
  <div class="am-tabs-arrow" v-bind="$attrs" v-on="$listeners">
    <div class="mdc-button__ripple"></div>
    <am-icon :icon="icon" />
  </div>
</template>

<script>
import { MDCRipple } from "@material/ripple";
import { AmIcon } from "../Icon";

export default {
  components: {
    AmIcon
  },
  props: {
    icon: {
      type: String
    }
  },
  data() {
    return {
      mdcRipple: undefined
    };
  },
  mounted() {
    this.mdcRipple = new MDCRipple(this.$el);
  },
  beforeDestroy() {
    if (this.mdcRipple) {
      this.mdcRipple.destroy();
    }
  }
};
</script>
